declare namespace $ {

	type $mol_view__dom_name_shm_hitalama_map_pane_tool_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_pane_tool_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_pane_tool_3 = $mol_type_enforce<
		({ 
			'points': ReturnType< $shm_hitalama_map_pane_tool['stroke_points'] >,
			'fill': string,
			'stroke': ReturnType< $shm_hitalama_map_pane_tool['stroke_color'] >,
			'stroke-width': ReturnType< $shm_hitalama_map_pane_tool['stroke_width'] >,
			'stroke-linecap': string,
			'stroke-linejoin': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__dom_name_shm_hitalama_map_pane_tool_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_pane_tool_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_pane_tool_6 = $mol_type_enforce<
		({ 
			'x': ReturnType< $shm_hitalama_map_pane_tool['shape_x'] >,
			'y': ReturnType< $shm_hitalama_map_pane_tool['shape_y'] >,
			'width': ReturnType< $shm_hitalama_map_pane_tool['shape_width'] >,
			'height': ReturnType< $shm_hitalama_map_pane_tool['shape_height'] >,
			'fill': ReturnType< $shm_hitalama_map_pane_tool['shape_fill'] >,
			'stroke': ReturnType< $shm_hitalama_map_pane_tool['stroke_color'] >,
			'stroke-width': ReturnType< $shm_hitalama_map_pane_tool['stroke_width'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__dom_name_shm_hitalama_map_pane_tool_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_pane_tool_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_pane_tool_9 = $mol_type_enforce<
		({ 
			'cx': ReturnType< $shm_hitalama_map_pane_tool['circle_cx'] >,
			'cy': ReturnType< $shm_hitalama_map_pane_tool['circle_cy'] >,
			'rx': ReturnType< $shm_hitalama_map_pane_tool['circle_rx'] >,
			'ry': ReturnType< $shm_hitalama_map_pane_tool['circle_ry'] >,
			'fill': ReturnType< $shm_hitalama_map_pane_tool['shape_fill'] >,
			'stroke': ReturnType< $shm_hitalama_map_pane_tool['stroke_color'] >,
			'stroke-width': ReturnType< $shm_hitalama_map_pane_tool['stroke_width'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__dom_name_shm_hitalama_map_pane_tool_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_pane_tool_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_pane_tool_12 = $mol_type_enforce<
		({ 
			'viewBox': ReturnType< $shm_hitalama_map_pane_tool['view_box'] >,
			'preserveAspectRatio': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_pane_tool_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane_tool['draft_views'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_vector_2d__shm_hitalama_map_pane_tool_14 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	export class $shm_hitalama_map_pane_tool extends $mol_view {
		pointer_events( ): string
		view_box( ): string
		stroke_points( ): string
		stroke_color( ): string
		stroke_width( ): string
		Stroke( ): $mol_view
		shape_x( ): string
		shape_y( ): string
		shape_width( ): string
		shape_height( ): string
		shape_fill( ): string
		Rect( ): $mol_view
		circle_cx( ): string
		circle_cy( ): string
		circle_rx( ): string
		circle_ry( ): string
		Circle( ): $mol_view
		draft_views( ): readonly(any)[]
		Svg( ): $mol_view
		tool_sub( ): readonly(any)[]
		Map_page( ): $shm_hitalama_map_page
		mode( ): string
		client_pos_to_pane_pos( id: any): any
		to_real_pos( id: any): any
		zoom( next?: number ): number
		pan( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		event_start( next?: any ): any
		event_move( next?: any ): any
		event_end( next?: any ): any
		draft_start( next?: any ): any
		draft_end( next?: any ): any
		draft_line( next?: any ): any
		draft_frozen( next?: boolean ): boolean
		auto( ): readonly(any)[]
		style( ): ({ 
			'pointerEvents': ReturnType< $shm_hitalama_map_pane_tool['pointer_events'] >,
		})  & ReturnType< $mol_view['style'] >
		sub( ): ReturnType< $shm_hitalama_map_pane_tool['tool_sub'] >
	}
	
}

//# sourceMappingURL=tool.view.tree.d.ts.map